import {Button, Card, css, Stack, styled} from '@mui/material';
import {SelectCardListProps} from './types';

const SelectCardList = styled(Card)<SelectCardListProps>`
	border: 1px solid transparent;
	${({theme}) => css`
		background-color: ${theme.colors.light.info['30Percent']};
	`}
	background-repeat: no-repeat;
	background-position: 95%;
	background-size: auto 100%;
	min-height: 68px;

	${({selected, theme}) =>
		selected &&
		css`
			border: 1px solid ${theme.palette.success.main};
		`}
`;

const SelectCardGrid = styled(Stack)`
	padding: 16px;
	gap: 8px;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	height: 68px;
`;

const StyledButton = styled(Button)`
	padding: 0;
	margin-right: auto;
	text-decoration: underline;
	font-size: 14px;
	line-height: 1;
	letter-spacing: 0.15px;
	color: ${({theme}) => theme.palette.primary.main};
`;

export {StyledButton, SelectCardList, SelectCardGrid};
